export * from "./favorites-page.component";
